import { useEffect, useRef, useState } from 'react';

const philosophyItems = [
  {
    icon: 'ri-seedling-line',
    title: '慢慢來，才走得遠',
    desc: '我們不追趕進度，不比較速度。每個人的學習節奏不同，這裡允許你停留、允許你反覆，允許你用自己的方式靠近音樂。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '陪伴，而不是指導',
    desc: '教學不是套用標準，而是陪著你找到適合現在的方式。我更在意你每次課後的感受，勝過你彈出什麼曲目。',
  },
  {
    icon: 'ri-leaf-line',
    title: '讓音樂融入生活',
    desc: '學古箏不該是另一種壓力。理想的狀態是，它能成為你在忙碌生活中，屬於自己的安靜時刻。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '心理安全，才有真學習',
    desc: '在這裡，你不需要擔心彈錯被評判，不需要假裝自己學得很快。安心的環境，是所有學習的起點。',
  },
];

export default function PhilosophySection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-32 bg-[#f2ede5]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="divider-gold"></div>
            <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">Philosophy</span>
            <div className="divider-gold"></div>
          </div>
          <h2
            className="font-serif-tc text-[#2c2420] leading-[1.4]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
          >
            教學理念
          </h2>
          <p className="mt-4 text-[1.1875rem] leading-[1.75] text-[#7a6e62] max-w-xl mx-auto">
            音樂不是用來比較或證明自己的。<br className="hidden md:block" />
            這裡重視的，是你是否感到安心與穩定。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {philosophyItems.map((item, i) => (
            <div
              key={i}
              className={`bg-[#faf8f5] rounded-2xl p-8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#e8ddd0] mb-6">
                <i className={`${item.icon} text-[#7a6248] text-xl`}></i>
              </div>
              <h3
                className="font-serif-tc text-[#2c2420] mb-4 leading-[1.5]"
                style={{ fontSize: '1.125rem' }}
              >
                {item.title}
              </h3>
              <p className="text-[1rem] leading-[1.75] text-[#7a6e62]">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
